import { useQuery, UseQueryResult } from "react-query";
import { ErrorMessage, ObjectType } from "../types";
import axios, { AxiosError } from "axios";

export const useScadaPlusQuery = <T>(
  queryName: string,
  url: string | (() => string),
  refetchInterval?: number | undefined,
  onError?: (errorMessage: ErrorMessage) => void,
  onSuccess?: (data: T) => void,
): UseQueryResult<T, ErrorMessage> => {
  const options: ObjectType<unknown> = {
    retry: false, // by default, react-query retries 3 times on failure
  };

  if (refetchInterval) {
    options["refetchInterval"] = refetchInterval;
  }

  if (onSuccess) {
    options["onSuccess"] = onSuccess;
  }

  if (onError) {
    options["onError"] = onError;
  }

  return useQuery<T, ErrorMessage>(
    queryName,
    async () => {
      try {
        const response = await axios.get(typeof url === "string" ? url : url());
        return response.data;
      } catch (e) {
        const error = e as AxiosError;
        throw {
          status: error.response?.status,
          text: error.response?.statusText ?? error.message,
        } as ErrorMessage;
      }
    },
    options,
  );
};
